import { PageShell } from '@/components/layout/PageShell'

interface PlaceholderProps {
	title: string
	description?: string
}

export default function Placeholder({ title, description = "This page hasn't been built out yet. Keep prompting to fill in this page's content." }: PlaceholderProps) {
	return (
		<PageShell centered className='py-24'>
			<span className='rounded-full bg-accent px-3 py-1 text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground'>Coming soon</span>
			<h1 className='text-2xl font-bold tracking-[-0.21px] text-foreground sm:text-3xl'>{title}</h1>
			<p className='max-w-md text-sm leading-[132%] text-muted-foreground'>{description}</p>
		</PageShell>
	)
}
